const BASIC_COL_SIZE = 210;

export const useColumnTemplate = (totalCols, columnWidths = 0, fullStretch = false, hidePlaceholder = false) => {
    const cols = [...Array(totalCols).keys()];

    const createTemplate = () => {
        return cols
            .map((col) => {
                if (col === 0) {
                    return `${columnWidths[col] ? columnWidths[col] : BASIC_COL_SIZE}px`;
                }

                if (col === cols.length - 1) {
                    return hidePlaceholder ? `minmax(auto, 1fr)` : `minmax(${BASIC_COL_SIZE}px, 1fr)`;
                }

                return columnWidths && columnWidths[col] && !fullStretch ? `minmax(${BASIC_COL_SIZE}px, ${columnWidths[col]}px)` : "1fr";
            })
            .join(" ");
    };

    return {
        gridTemplateColumns: createTemplate(),
    };
};
